import { CompEvalWeekPills } from './CompEvalPill';
import { useCompEvalDates } from '../lib/compEvalsClient';
import { offeringFeedHref, useOfferings } from '../lib/offerings';
import { offeringAssistantUids, offeringWeeklyTeacherUids } from '../lib/offeringTeachers';
import { staffCompEvalOfferingIds } from '../lib/compEvals';
import { withoutTemporarySubSeats } from '../lib/subSeatSchedule';
import { studioDayKey } from '../lib/studioDay';
import { useAuth } from '../lib/auth-context';
import { useUserDoc } from '../lib/users';
import { isOwnJrStaffSignIn } from '../lib/jrStaffAliases';
import { useOwnSignInUids } from '../lib/ownSignIns';
import { loadClassPostOwnSignInUids } from '../lib/classPosts';
import { useStudentById } from '../lib/students';

/**
 * The staff home's eval pills this week: a Director or Manager sees every
 * comp class's, anyone else the classes they teach (their weekly team).
 * A Jr Staff is ONE PERSON on either sign-in (CLAUDE.md): on her staff
 * sign-in this also counts every uid that is hers, the classes she
 * assists and the classes she dances in, the same set her dancer sign-in gets from the portal.
 * Self-contained so each home mounts one line. Draws nothing when no eval
 * falls this week.
 */
export function StaffCompEvalWeekPills() {
  const { user } = useAuth();
  const { userDoc } = useUserDoc();
  const uid = userDoc?.status === 'active' ? user?.uid ?? null : null;
  const role = userDoc?.role ?? null;
  const seesAll = role === 'director' || role === 'manager';
  const ownUids = useOwnSignInUids(uid, userDoc, { askServer: loadClassPostOwnSignInUids });
  const jrStaffStudentId = uid && userDoc
    && isOwnJrStaffSignIn({ uid, role, status: userDoc.status ?? null, studentId: userDoc.studentId ?? null })
    ? userDoc.studentId ?? null
    : null;
  const { student } = useStudentById(jrStaffStudentId);
  const dances = new Set(jrStaffStudentId && student?.id === jrStaffStudentId ? student.memberships : []);
  const { dates } = useCompEvalDates(!!uid);
  const { offerings } = useOfferings(!!uid && dates.size > 0);
  const todayKey = studioDayKey(Date.now());
  const shown = new Set(staffCompEvalOfferingIds({
    rows: offerings.map((offering) => ({
      id: offering.id,
      teacherUids: offeringWeeklyTeacherUids(offering),
      assistantUids: offeringAssistantUids(withoutTemporarySubSeats(offering)),
    })),
    datedIds: dates,
    ownUids,
    dancesIn: dances,
    seesAll,
  }));
  const names = new Map<string, string>();
  for (const offering of offerings) {
    if (shown.has(offering.id)) names.set(offering.id, offering.name);
  }
  const entries = [...dates.values()].filter((entry) => names.has(entry.offeringId));
  return (
    <CompEvalWeekPills
      entries={entries}
      classNames={names}
      todayKey={todayKey}
      hrefFor={offeringFeedHref}
      style={{ margin: '8px 0' }}
    />
  );
}
